import React, { useState, useEffect, useCallback, useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import usePrevious from 'utils/customHook/usePrevious';
import paramSetterReducer from 'utils/customReducer/paramSetterReducer';
import { customAxiosGetFunction } from 'utils/axiosFunction';
import { getYMDFormatDate } from 'utils/getCustomFormatDate';
import Table from 'utils/table/Table';
import { nvl } from 'utils/nvl';
import makeDataLevel from './makeDataLevel';
import { columnSetter } from './columns';

import { Styles } from 'utils/table/Table.css.js';

const GasDetailTable = ({ flag, searchMap, gasCriterion }) => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [canNextPage, setCanNextPage] = useState(false);
  const [canPreviousPage, setCanPreviousPage] = useState(false);
  const [paramState, dispatch] = useReducer(paramSetterReducer, {
    pageIndex: 0,
    pageCount: 0,
    pageSize: 15,
    elementCount: 0,
  });
  const [columns, setColumns] = useState(columnSetter(0));
  const { date, autoReloadTime, moduleIdx, beginTime, endTime } = searchMap;
  const prevAmount = usePrevious({ date, autoReloadTime, moduleIdx, beginTime, endTime });

  const searchTable = useCallback(() => {
    customAxiosGetFunction(history, '/api/gas/search', {
      params: {
        ...paramState,
        date: getYMDFormatDate(searchMap.date),
        moduleIdx: searchMap.moduleIdx,
        beginTime: searchMap.beginTime,
        endTime: searchMap.endTime,
      },
    }).then((response) => {
      if (nvl(response, null) === null) {
        return false;
      }

      dispatch({ type: 'CHANGE_TOTAL', pageCount: response.totalPages, elementCount: response.totalElements });
      setCanNextPage(!response.last);
      setCanPreviousPage(!response.first);

      setData(
        nvl(response.content, [])
          .filter(d => d.module && d.module.modelNm)
          .map((d, index) => {
          return {
            ...makeDataLevel(d, gasCriterion, paramState.pageIndex, paramState.pageSize, index),
          };
        })
      );
    });
  }, [paramState, searchMap]);

  useEffect(() => {
    if (Number(searchMap.autoReloadTime) === 0) {
      setColumns(columnSetter(searchMap.moduleScn, flag));
      searchTable();
    } else {
      if (prevAmount != searchMap) {
        setColumns(columnSetter(searchMap.moduleScn, flag));
        searchTable();
      }

      const timer = window.setInterval(() => {
        searchTable();
      }, Number(searchMap.autoReloadTime));

      return () => {
        window.clearInterval(timer);
      };
    }
  }, [paramState.pageIndex, searchMap]);

  return (
    <Styles>
      <Table
        columns={columns}
        data={data}
        pageIndex={paramState.pageIndex}
        pageSize={paramState.pageSize}
        pageCount={paramState.pageCount}
        elementCount={paramState.elementCount}
        canNextPage={canNextPage}
        canPreviousPage={canPreviousPage}
        setParamDispatch={dispatch}
      />
    </Styles>
  );
};

export default GasDetailTable;
